
import './App.css';
import Temp from './component/weather/temp';

function App() {
  return <>
  <Temp />
  </>
    
  
}

export default App;
